import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Stack } from "@mui/material";
import useStyles from "./styles";
import DashboardLayout from "../../layouts/DashboardLayout";
import CeroButton from "../../components/CeroButton";
import CeroTable from "../../components/CeroTable";
import dayjs from "dayjs";
import { listAnnouncement } from "../../redux/actions";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export const TableColumns = [
  {
    columnKey: "start_ts",
    columnId: "start_ts",
    columnHeader: "Start Time",
  },
  {
    columnKey: "end_ts",
    columnId: "end_ts",
    columnHeader: "End Time",
  },
  {
    columnKey: "type_of_message",
    columnId: "type_of_message",
    columnHeader: "Type of Message",
  },
  {
    columnKey: "type_of_notification",
    columnId: "type_of_notification",
    columnHeader: "Notification Type",
  },
  {
    columnKey: "status",
    columnId: "status",
    columnHeader: "Message Status",
  },
  {
    columnKey: "action",
    columnId: "action",
    columnHeader: "",
  },
];

const SuperAdminNotifications = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const announcementList = useSelector(
    (state) => state.superAdmin.listAnnouncement.data
  );

  const handleEditNotification = (item) => {
    navigate(`edit/${item}`);
  };

  useEffect(() => {
    dispatch(listAnnouncement());
  }, [dispatch]);

  const getTicketsList = () =>
    announcementList.map((item) => ({
      ...item,
      start_ts: item.start_ts
        ? dayjs(item.start_ts).format("DD MMM YYYY hh:mm A")
        : "-",
      end_ts: item.end_ts
        ? dayjs(item.end_ts).format("DD MMM YYYY hh:mm A")
        : "-",
      action: (
        <>
          <div className={classes.actions}>
            <div
              className={classes.linkButton}
              onClick={(e) => {
                handleEditNotification(item.id);
                e.stopPropagation();
              }}
            >
              Edit
              <EditOutlinedIcon className={classes.editIcon} />
            </div>
          </div>
        </>
      ),
    }));

  return (
    <DashboardLayout>
      <Container className={classes.container}>
        <Stack direction="row" justifyContent="flex-end">
          <CeroButton
            buttonText="Add notification"
            className={classes.buttonPrimary}
            onClick={() => navigate("/add-notifications")}
          />
        </Stack>
        <CeroTable
          columns={TableColumns}
          data={getTicketsList()}
          hasMore={false}
          loading={false}
          classes={{ tableContainer: classes.tableContainer }}
        />
      </Container>
    </DashboardLayout>
  );
};

export default SuperAdminNotifications;
